import React, { useContext, useEffect } from 'react';
import { useLocation, Switch } from 'react-router-dom';

import Loading from 'components/common-sfims/Loading';
import Progress from 'components/common-sfims/Progress';
import NavbarTop from 'components/navbar/top/NavbarTop';
import AppContext from 'context/Context';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import { getLoginInform } from 'function/login';
import SFMSRoutes from 'layouts/SFMSRoutes';
import SFSHRoutes from 'layouts/SFSHRoutes';
import { RETURN_YN } from 'types/type';

/**
 * 메인 레이아웃
 */
const MainLayout = () => {
  /* variable */
  const { haccpYn } = getLoginInform();

  /* context */
  const {
    config: { isFluid, navbarPosition }
  } = useContext(AppContext);

  /* router */
  const { hash, pathname } = useLocation();

  /* watch */
  useEffect(() => {
    setTimeout(() => {
      if (!hash) {
        return;
      }

      const element = document.getElementById(hash.substring(1));

      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);
  }, []);
  useEffect(() => {
    scrollTo(0, 0);
  }, [pathname]);

  /* view */
  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      <div className="content">
        <NavbarTop />
        <Switch>
          {haccpYn === RETURN_YN.Y ? <SFSHRoutes /> : <SFMSRoutes />}
        </Switch>
      </div>
      <Loading />
      <Progress />
    </div>
  );
};

export default MainLayout;
